import { render } from "./ServiceAccount.vue?vue&type=template&id=12890261&ts=true"
import script from "./ServiceAccount.vue?vue&type=script&lang=ts"
export * from "./ServiceAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__